import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import AgentPrompt from "../../integrate/_snippets/agent-prompt.mdx";
import DetailSetUpReverseProxy from "../../integrate/_snippets/details/set-up-reverse-proxy.mdx";
import DetailGroupProductsInOneProject from "../../integrate/_snippets/details/group-products-in-one-project.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Install PostHog in seconds with our wizard by running this command in your project directory with your terminal (it also works for `}<a parentName="p" {...{
        "href": "/blog/envoy-wizard-llm-agent"
      }}>{`LLM coding agents`}</a>{` like Cursor and Bolt):`}</p>
    <AgentPrompt mdxType="AgentPrompt" />
    <p>{`Wait for it to finish and test the setup once the wizard is complete.`}</p>
    <p>{`The wizard supports React, Next.js, Svelte, and React Native. We've got more on the way.`}</p>
    <p>{`Check out the wizard's `}<a parentName="p" {...{
        "href": "https://github.com/PostHog/wizard"
      }}>{`GitHub repo`}</a>{` for more details.`}</p>
    <DetailSetUpReverseProxy mdxType="DetailSetUpReverseProxy" />
    <DetailGroupProductsInOneProject mdxType="DetailGroupProductsInOneProject" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      